import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const CheckListElem = styled.li`
  &::before {
    content: '';
    display: inline-block;
    min-height: 1rem;
    min-width: 1rem;
    background-image: url('/assets/svg/check-mark.svg');
    background-size: contain;
    margin-right: 1rem;
  }
`;

const CheckListRowElem = styled.div`
  @media (min-width: ${fullConfig.theme.screens.md}) {
    min-height: 300px;
  }

  @media (min-width: ${fullConfig.theme.screens.xl}) {
    min-height: 500px;
  }
`;

const CheckImageWrap = styled.figure.attrs(() => {
  const classNameToAdd = [
    'p-4',
    'md:p-0',
    'md:absolute',
    'md:right-0',
    'md:left-1/2',
    'md:w-1/2',
    'md:top-0',
    'md:bottom-0',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

export { CheckListElem, CheckListRowElem, CheckImageWrap };
